import React from "react";
import useKeyPress from "../hooks/useKeyPress";
import { BORDERRADIUS as borderRadius } from "@fedsim/constants";

import { InputBase, Paper } from "@mui/material";
import { NOOP } from "@fedsim/helpers";

export function ListSearch({ onChange = NOOP, children = null }) {
  const changeHandler = (event) => onChange(event.target.value);
  useKeyPress("Escape", () => {
    onChange("");
  });
  return (
    <Paper
      component="form"
      sx={{
        p: "2px 4px",
        borderRadius,
        display: "flex",
        alignItems: "center",
      }}
    >
      {children}
      <InputBase
        size="medium"
        sx={{ ml: 1, flex: 1 }}
        placeholder="Quick search"
        inputProps={{ "aria-label": "search collection" }}
        onChange={changeHandler}
      />
    </Paper>
  );
}

export default ListSearch;
